import { StepsLayout } from "@funded-here-interface/common";
import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { FC, ReactNode, Suspense } from "react";

import NavBar from "../../components/NavBar/NavBar";
import { useStyles } from "./Newonboardinglayout.styles";

interface IProps {
  content: ReactNode;
  showSteps?: boolean;
  step: number;
  totalSteps?: number;
}

const NewOnboardingLayout: FC<IProps> = (props) => {
  const { content, showSteps, step, totalSteps } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer} style={{ backgroundColor: "#fff" }}>
      <NavBar />

      {showSteps && <StepsLayout currentStep={step} totalSteps={totalSteps} />}
      <div className={classes.stepContainer2}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default NewOnboardingLayout;
